import type { DateTime } from 'luxon';
import { ERROR_MESSAGES } from '@library/constants/errorMessages';
import { ErrorMessage } from '@library/components/messages/ErrorMessage';
import type { TimeValidations } from '@library/types/dates';

export interface TimeErrorMessagesProps {
  readonly isContextValidations?: boolean;
  readonly maxTime?: DateTime;
  readonly minTime?: DateTime;
  readonly validations?: TimeValidations;
}

export function TimeErrorMessages({
  isContextValidations = false,
  maxTime = undefined,
  minTime = undefined,
  validations = {
    isAfterMax: false,
    isBeforeMin: false,
    isError: false,
    isHourError: false,
    isHourValid: true,
    isMinuteError: false,
    isMinuteValid: true
  }
}: TimeErrorMessagesProps) {
  const {
    isAfterMax,
    isBeforeMin,
    isHourValid,
    isMinuteValid,
    uniqueStartTimes = []
  } = validations;

  return (
    <>
      <ErrorMessage
        failedValidation={isAfterMax}
        failureMessages={maxTime ? ERROR_MESSAGES.MAX_TIME(maxTime) : []}
        testId="max-time-error"
      />
      <ErrorMessage
        failedValidation={isBeforeMin}
        failureMessages={minTime ? ERROR_MESSAGES.MIN_TIME(minTime) : []}
        testId="min-time-error"
      />
      <ErrorMessage
        failedValidation={!isHourValid}
        failureMessages={ERROR_MESSAGES.INVALID_HOUR(isContextValidations)}
        testId="invalid-hour-error"
      />
      <ErrorMessage
        failedValidation={!isMinuteValid}
        failureMessages={ERROR_MESSAGES.INVALID_MINUTE(isContextValidations)}
        testId="invalid-minute-error"
      />
      <ErrorMessage
        failedValidation={uniqueStartTimes?.length > 1}
        failureMessages={ERROR_MESSAGES.MULTIPLE_START_TIMES(uniqueStartTimes)}
        testId="multiple-start-time-error"
      />
    </>
  );
}
